import { render, staticRenderFns } from "./FullScreenPreview.vue?vue&type=template&id=34d1a874&scoped=true"
import script from "./FullScreenPreview.vue?vue&type=script&lang=js"
export * from "./FullScreenPreview.vue?vue&type=script&lang=js"
import style0 from "./FullScreenPreview.vue?vue&type=style&index=0&id=34d1a874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d1a874",
  null
  
)

export default component.exports